import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface TextFieldSuffixProps {
    suffix: string
}

@Dce("TextFieldSuffix")
export default class TextFieldSuffix extends DceComponent<TextFieldSuffixProps> {

    private input: JQuery<HTMLElement>;

    private toggle: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: TextFieldSuffixProps) {
        super(elem, props);
        this.input = $(elem);
        this.toggle = $('<span class="text-field-suffix">' + props.suffix + '</span>');

        this.addSuffix();

    }

    private addSuffix(){
        let height = parseInt(this.input.css('height'));

        if(height == 0){
            setTimeout(() => {
                this.addSuffix();
            }, 200);
            return;
        }

        var iconHeight = height;
        if(iconHeight > 24){
            iconHeight = 24;
        }

        if(height <= 24){
            iconHeight = 0.8 * height;
        }

        this.toggle.css({
            'font': this.input.css('font'),
            'height': this.input.css('height')
        });

        this.input.after(this.toggle);

        this.toggle.css({
            'margin-left': (-1 * this.toggle.outerWidth() - 10) + 'px'
        });

    }

}
